import { FastlyImage } from '@components/common/image'

type TextImageCommonFoldProps = {
  title: string | JSX.Element
  description: string | JSX.Element
  imagePath?: string
  imageWidth?: number
  imageHeight?: number
  containerClassName?: string
  titleClassName?: string
  descriptionClassName?: string
  textColorClassName?: string
  reverse?: boolean
}

const TextImageCommonFold = ({
  title,
  description,
  imagePath,
  imageWidth,
  imageHeight,
  containerClassName,
  titleClassName,
  descriptionClassName,
  textColorClassName,
  reverse = false,
}: TextImageCommonFoldProps) => {
  const textColorClass = textColorClassName ? textColorClassName : 'text-grey'

  return (
    <div
      className={`container mx-auto flex flex-col space-y-10 py-12 lg:py-16 px-5 relative ${textColorClass} ${
        containerClassName ?? ''
      }`.trim()}
    >
      <h2
        className={`text-2xl lg:text-4xl font-600 lg:mb-3 text-center ${
          titleClassName ?? ''
        }`.trim()}
      >
        {title}
      </h2>
      <div
        className={`flex flex-col items-center lg:flex-row gap-y-10 lg:gap-y-0 lg:gap-x-10 justify-between mb-12 ${
          reverse ? 'lg:flex-row-reverse' : ''
        }`.trim()}
      >
        <div
          className={`text-lg lg:text-xl w-full lg:w-3/5 text-center lg:text-left space-y-2 ${
            descriptionClassName ?? ''
          }`.trim()}
        >
          {description}{' '}
        </div>
        <FastlyImage
          src={
            imagePath
              ? `${imagePath}.png`
              : `/images/home/student-certificate.png`
          }
          alt="Coding Certificate"
          webpSrc={
            imagePath
              ? `${imagePath}.webp`
              : `/images/home/student-certificate.webp`
          }
          width={imageWidth ? imageWidth : 438}
          height={imageHeight ? imageHeight : 375}
        />
      </div>
    </div>
  )
}

export default TextImageCommonFold
